import { type FC, useRef } from "react";
import { LinkButton } from "../../../../../common/components/Link";
import { useBooleanState } from "../../../../../common/hooks/useBooleanState";
import { QuickEntryPopup } from "~/features/quickEntry/components/QuickEntryPopup";
import { QuickEntryPopup as QuickEntryPopupV2 } from "~/features/quickEntry/v2/QuickEntryPopup";
import { useTranslation } from "react-i18next";
import { userIsCustomer } from "~/domains/user/utils/roles";
import { hasProductConfiguredPC } from "~/features/quickEntry/utils/helpers";
import { type QuickEntryItem } from "~/features/quickEntry/types/models";
import { addProductsToCartAction } from "~/features/quickEntry/redux/quickEntryActions";
import { addMessage } from "~/features/toasts/redux/actions";
import { useDispatch } from "react-redux";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

interface BulkATCButtonProps {
  className?: string;
  disabled?: boolean;
}

export const EnterDesignationBtn: FC<BulkATCButtonProps> = ({ className, disabled = false }) => {
  const { val, setTrue, setFalse } = useBooleanState(false);
  const { t } = useTranslation();

  const isB2C = !userIsCustomer(); // check this
  const dispatch = useDispatch();
  const disabledRef = useRef(disabled);
  disabledRef.current = disabled;

  const openPopup = () => {
    if (!disabledRef.current) {
      setTrue();
    }
  };

  return (
    <>
      <LinkButton
        iconBefore={<AddOutlinedIcon />}
        onClick={openPopup}
        disabled={disabled}
        data-test-id={"btn-enter-designation"}
        className={className}
      >
        {t("cartPage.btn.designation")}
      </LinkButton>
      {val && !disabled && !isB2C && <QuickEntryPopup onClose={setFalse} />}
      {val && !disabled && isB2C && (
        <QuickEntryPopupV2
          variant={"b2c-cart"}
          onClose={setFalse}
          onAdd={async (form, setIsSending, onClose) => {
            if (disabledRef.current) {
              return;
            }

            const items = form.items?.filter(hasProductConfiguredPC) ?? [];
            const modifiedItems = items.map((item: QuickEntryItem) => {
              const filteredProductId = item.productId.replace(/-/g, "");
              const isMatNo = !!parseInt(filteredProductId) && filteredProductId.length == 15;

              return {
                ...item,
                productId: isMatNo ? filteredProductId : item.productId,
                packCode: isMatNo ? filteredProductId.substring(13, 15) : item.packCode,
              };
            });
            setIsSending(true);
            await dispatch(addProductsToCartAction(modifiedItems));
            setIsSending(false);
            if (items.length > 0) {
              dispatch(addMessage("info", t("addToCart.success", { count: items.length })));
            }
            onClose();
          }}
          addButtonLabel={t("addToCartPopup.add.submitBtn")}
        />
      )}
    </>
  );
};
